import axios from 'axios';

const WIDGET_OPENED_STORAGE_PREFIX = 'firstin:widget-opened:';

const trackWidgetOpen = async (clinicId: string, source: string) => {
  if (!clinicId || !source) {
    return;
  }

  const storageKey = `${WIDGET_OPENED_STORAGE_PREFIX}${clinicId}`;

  const isWidgetAlreadyTracked = sessionStorage.getItem(storageKey);

  if (isWidgetAlreadyTracked) {
    return;
  }

  sessionStorage.setItem(storageKey, '1');

  try {
    await axios.post(
      '/widget/events',
      { clinicId, source },
      { baseURL: process.env.REACT_APP_AXIOS_BE_URL }
    );
  } catch {}
};

export default trackWidgetOpen;
